import { render, staticRenderFns } from "./DeleteIcon.vue?vue&type=template&id=ee8ba12c"
import script from "./DeleteIcon.vue?vue&type=script&lang=js"
export * from "./DeleteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports